class Calendar {
  constructor(events, onDateSelect, onClearFilters) {
    this.events = events;
    this.onDateSelect = onDateSelect;
    this.onClearFilters = onClearFilters;
    this.selectedDate = null;
    this.currentDate = new Date();
  }

  buildCalendar() {
    const calendarContainer = document.createElement('div');
    calendarContainer.classList.add('calendar-container');

    const header = this.buildHeader();
    const daysGrid = this.buildDaysGrid();

    calendarContainer.appendChild(header);

    // Add clear selected date button (hidden by default)
    const clearDateBtn = document.createElement('button');
    clearDateBtn.className = 'calendar-clear-date-btn hidden';
    clearDateBtn.textContent = 'Clear Selected Date';
    clearDateBtn.type = 'button';
    clearDateBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.selectedDate = null;
      if (typeof this.onClearFilters === 'function') {
        this.onClearFilters();
      }
      this.updateCalendar();
    });
    calendarContainer.appendChild(clearDateBtn);

    // Show/hide the button based on selectedDate
    if (this.selectedDate) {
      clearDateBtn.classList.remove('hidden');
    } else {
      clearDateBtn.classList.add('hidden');
    }

    calendarContainer.appendChild(daysGrid);

    return calendarContainer;
  }

  buildHeader() {
    const header = document.createElement('div');
    header.classList.add('calendar-header');

    const monthYear = document.createElement('div');
    monthYear.classList.add('calendar-month-year');
    monthYear.textContent = this.currentDate.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });

    const prevButton = document.createElement('button');
    prevButton.textContent = '<';
    prevButton.classList.add('calendar-nav');
    prevButton.addEventListener('click', () => {
      this.currentDate.setMonth(this.currentDate.getMonth() - 1);
      this.updateCalendar();
    });

    const nextButton = document.createElement('button');
    nextButton.textContent = '>';
    nextButton.classList.add('calendar-nav');
    nextButton.addEventListener('click', () => {
      this.currentDate.setMonth(this.currentDate.getMonth() + 1);
      this.updateCalendar();
    });

    header.appendChild(prevButton);
    header.appendChild(monthYear);
    header.appendChild(nextButton);

    return header;
  }

  clearUrlParams() {
    const params = new URLSearchParams(window.location.search);
    params.delete('selectedDate');
    params.delete('filterEvent');
    params.delete('filterStore');
    params.delete('page');
    params.delete('flyerOpen');
    history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
  }

  buildDaysGrid() {
    const daysGrid = document.createElement('div');
    daysGrid.classList.add('calendar-days-grid');

    const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    daysOfWeek.forEach((day) => {
      const dayElement = document.createElement('div');
      dayElement.classList.add('calendar-day-header');
      dayElement.textContent = day;
      daysGrid.appendChild(dayElement);
    });

    const firstDayOfMonth = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1);
    const lastDayOfMonth = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0);

    // Fill days of the month
    for (let day = 1; day <= lastDayOfMonth.getDate(); day++) {
      const date = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), day);
      const dayCell = document.createElement('div');
      dayCell.classList.add('calendar-day');
      dayCell.textContent = day;

      // Set gridColumnStart for the first day
      if (day === 1) {
        dayCell.style.gridColumnStart = firstDayOfMonth.getDay() + 1; // +1 because CSS grid columns are 1-based
      }

      // Highlight days with events
      const hasEvent = this.events.some((event) => {
        const eventDate = new Date(event.start);
        return eventDate.toDateString() === date.toDateString();
      });
      if (hasEvent) {
        dayCell.classList.add('calendar-day-event');
      }

      // Highlight selected date
      if (this.selectedDate && date.toDateString() === this.selectedDate.toDateString()) {
        dayCell.classList.add('calendar-day-selected');
      }

      dayCell.addEventListener('click', () => {
        this.selectedDate = date;
        this.onDateSelect(date);
        this.updateCalendar();
      });

      daysGrid.appendChild(dayCell);
    }

    return daysGrid;
  }

  updateCalendar() {
    const calendarContainer = document.querySelector('.calendar-container');
    if (calendarContainer) {
      calendarContainer.innerHTML = '';
      calendarContainer.appendChild(this.buildHeader());
      calendarContainer.appendChild(this.buildDaysGrid());
    }
  }

  render(selector) {
    const container = document.querySelector(selector);
    if (!container) {
      console.error(`Selector "${selector}" not found.`);
      return;
    }

    container.innerHTML = ''; // Clear any existing content
    container.appendChild(this.buildCalendar());
  }

  rebuild(newEvents) {
    this.events = newEvents;
    this.updateCalendar();
  }
}
